import type { ThemeConfig } from "antd";

export const theme: ThemeConfig = {
  token: {
    colorPrimary: "#2563eb",
    colorInfo: "#2563eb",
    colorSuccess: "#10b981",
    colorWarning: "#f59e0b",
    colorError: "#ef4444",
    colorTextBase: "#0f172a",
    colorBorderSecondary: "#eef2f6",
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    borderRadius: 8,
    controlHeight: 36,
  },
  components: {
    Button: {
      controlHeight: 36,
      controlHeightLG: 44,
      fontWeight: 500,
      primaryShadow: "0 1px 2px rgba(37,99,235,0.25)",
    },
    Input: {
      controlHeight: 36,
    },
    Select: {
      controlHeight: 36,
    },
    InputNumber: {
      controlHeight: 36,
    },
    Table: {
      cellPaddingBlock: 14,
      headerBg: "#f8fafc",
      headerColor: "#64748b",
      headerSplitColor: "transparent",
      borderColor: "#eef2f6",
      rowHoverBg: "#f8fafc",
      cellFontSize: 14,
    },
    Tabs: {
      titleFontSize: 14,
      inkBarColor: "#2563eb",
      itemSelectedColor: "#0f172a",
      itemColor: "#64748b",
      horizontalItemGutter: 24,
    },
    Modal: {
      borderRadiusLG: 12,
    },
    Card: {
      borderRadiusLG: 12,
    },
    Segmented: {
      borderRadius: 8,
    },
  },
};
